<template lang="html">
  <boxwrap class="menu--inner">
    <toolbar></toolbar>
    <boxwrap-contents>
      <tbl
        :scrollable="true"
      >
        <tbl-inner >
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="order"
              >
                no
              </tbl-td>
              <tbl-td
                name="menu"
              >
                menu
              </tbl-td>

              <tbl-td
                name="actions"
              >
                show
              </tbl-td>

              <tbl-td
                name="down"
              >
                down
              </tbl-td>

              <tbl-td
                name="up"
              >
                up
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(nav, x) in menu"
              :key="nav.id"
            >
              <tbl-td
                name="order"
              >
                {{ nav.order }}
              </tbl-td>
              <tbl-td
                name="menu"
              >
                {{ nav.menu }}
              </tbl-td>

              <tbl-td
                name="actions"
              >
              <checkbox
                type="toggle"
                :class="{'-active': !nav.is_hide}"
                :toggleA="!nav.is_hide ? 'show' : 'hide'"
                :toggleB="!nav.is_hide ? 'show' : 'hide'"
                @click.native="visibility(nav)"
              >
                <input
                  type="checkbox"
                  v-model="nav.is_hide"
                />
              </checkbox>
              </tbl-td>

              <tbl-td
                name="down"
              >
                <button class="btn--default btn--down" @click="changeOrder('down', nav)">
                  <i class="ico--arr-down"></i>
                </button>
              </tbl-td>

              <tbl-td
                name="up"
              >
              <button class="btn--default btn--up" @click="changeOrder('up', nav)">
                <i class="ico--arr-down"></i>
              </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import Checkbox from '@/components/base/Checkbox'

export default {
  name: 'menu',

  components: {
    Checkbox
  },

  data () {
    return {
      menu: []
    }
  },

  async created () {
    await this.get()
    this.menu = JSON.parse(JSON.stringify(this.menuList))
    this.menu = _.orderBy(this.menu, 'order', 'asc')
  },

  computed: {
    ...mapState('settings-menu', { menuList: 'menu' })
  },

  watch: {

  },

  methods: {
    ...mapActions('settings-menu', ['get', 'update']),
    ...mapMutations('settings-menu', ['SET_MENU']),
    async visibility (nav) {
      console.log('update me', nav.key, nav.is_hide)
      let d = Object.assign({}, nav)
      d.is_hide = !d.is_hide
      await this.update({ id: nav.id, data: d })
    },

    async changeOrder (direction, nav) {
      let idx = this.menu.findIndex((e) => {
        return e.id === nav.id
      })

      let xVal = direction === 'down' ? 1 : -1

      if (!this.menu[idx + xVal]) return

      let ordera = this.menu[idx + xVal].order
      let orderb = this.menu[idx].order
      console.log(ordera, orderb)
      let a = Object.assign({}, this.menu[idx + xVal])
      let b = Object.assign({}, this.menu[idx])

      a.order = orderb
      b.order = ordera

      this.menu[idx + xVal] = a
      this.menu[idx] = b

      for (var x = 0; x < this.menu.length; x++) {
        let chck = this.menuList.find((e) => {
          return parseInt(e.id) === parseInt(this.menu[x].id)
        })

        if (this.menu[x].order !== chck.order) {
          console.log('update me', this.menu[x].key)
          await this.update({ id: this.menu[x].id, data: this.menu[x] })
        }
      }

      this.SET_MENU(this.menu)
      this.menu = _.orderBy(this.menu, 'order', 'asc')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
